/* ==========================================================================
   MASHWI — Barre ATC fixe mobile
   Apparaît quand le formulaire d'achat principal a défilé hors du viewport.
   Vanilla, zéro dépendance. Le CSS limite l'affichage au mobile (≤ 749 px).
   ========================================================================== */
(function () {
  'use strict';

  var bar = document.querySelector('[data-mw-sticky-atc]');
  if (!bar) return;

  /* 5ᵉ passage (2026-07-31) : la boîte d'achat est la carte d'offre — son
     formulaire (.mw-offre__form) passe en tête de liste. Les sélecteurs Dawn
     restent en repli si la fiche classique revenait un jour. */
  var mainForm =
    document.querySelector('.mw-offre__form') ||
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector('.product-form form') ||
    document.querySelector('.product-form');

  if (!mainForm || !('IntersectionObserver' in window)) {
    // Pas de formulaire principal (ou navigateur trop vieux) : la barre reste cachée.
    bar.remove();
    return;
  }

  var submitProxy = bar.querySelector('[data-mw-sticky-submit]');

  function setVisible(visible) {
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (submitProxy) submitProxy.tabIndex = visible ? 0 : -1;
  }

  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[entries.length - 1];
    // Visible seulement quand le form est SORTI du viewport par le haut
    // (l'utilisateur a défilé plus bas que l'ATC principal).
    setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
  });

  observer.observe(mainForm);

  if (submitProxy) {
    submitProxy.addEventListener('click', function () {
      var realSubmit =
        mainForm.querySelector('.product-form__submit') ||
        mainForm.querySelector('[type="submit"]');

      if (realSubmit && !realSubmit.disabled) {
        // Passe par le bouton Dawn : product-form gère l'ajout AJAX + le drawer.
        realSubmit.click();
      } else if (typeof mainForm.requestSubmit === 'function') {
        mainForm.requestSubmit();
      }
    });
  }
})();
